module.exports = __webpack_public_path__ + "static/media/sidebar-2.ca6393ce.jpg";